import { createAction } from "@reduxjs/toolkit"
import _ from "lodash"
import { isIntlObject } from "../../i18n/useSmartFormat"

export const REMOVE_SNACKBAR = createAction("REMOVE_SNACKBAR")
export const removeSnackbar = (key) => REMOVE_SNACKBAR({ key })

function resolveMessageKey(message) {
  if (_.isString(message)) {
    return message
  }

  if (isIntlObject(message)) {
    return message.id
  }

  return new Date().getTime() + Math.random()
}

/**
 * Redux toolkit enqueue snack bar factory.
 */
export const ENQUEUE_SNACKBAR = createAction(
  "ENQUEUE_SNACKBAR",
  ({ key, ...payload }) => {
    // provide a key consistent key to prevent duplicates
    const { message } = payload
    return {
      payload: {
        ...payload,
        key: resolveMessageKey(message)
      }
    }
  }
)

/**
 * Create a snackbar action with DEFAULT variant.
 * @param message
 * @param options
 */
export const enqueueMessage = (message, options) =>
  ENQUEUE_SNACKBAR({
    message,
    options: { ...options, variant: "default" }
  })

/**
 * Create a snackbar action with ERROR variant.
 * @param message
 * @param options
 */
export const enqueueError = (message, options) =>
  ENQUEUE_SNACKBAR({
    message,
    options: { ...options, variant: "error" }
  })

/**
 * Create a snackbar action with SUCCESS variant.
 * @param message
 * @param options
 */
export const enqueueSuccess = (message, options) =>
  ENQUEUE_SNACKBAR({ message, options: { ...options, variant: "success" } })

/**
 * Create a snackbar action with INFO variant.
 * @param message
 * @param options
 */
export const enqueueInfo = (message, options) =>
  ENQUEUE_SNACKBAR({ message, options: { ...options, variant: "info" } })

/**
 * Create a snackbar action with WARNING variant.
 * @param message
 * @param options
 */
export const enqueueWarning = (message, options) =>
  ENQUEUE_SNACKBAR({ message, options: { ...options, variant: "warning" } })
